import React, { useState, useEffect, useRef } from "react";

const HideColumnIcon = ({ handleHideColumn, columnConfig }) => {
  const [isPending, setIsPending] = useState(false);
  const [progress, setProgress] = useState(0);
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);
  const startTimeRef = useRef(null);

  // Nettoyer les timeouts/intervals au démontage
  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const startCountdown = () => {
    setIsPending(true);
    setProgress(0);
    startTimeRef.current = Date.now();

    // Animation du cercle de progression
    intervalRef.current = setInterval(() => {
      const elapsed = Date.now() - startTimeRef.current;
      const newProgress = Math.min((elapsed / 1100) * 100, 100);
      setProgress(newProgress);

      if (newProgress >= 100) {
        clearInterval(intervalRef.current);
      }
    }, 16); // ~60fps

    // Programmer l'exécution après 1.1 secondes
    timeoutRef.current = setTimeout(() => {
      handleHideColumn();
      setIsPending(false);
      setProgress(0);
      if (intervalRef.current) clearInterval(intervalRef.current);
    }, 1100);
  };

  const cancelCountdown = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (intervalRef.current) clearInterval(intervalRef.current);
    setIsPending(false);
    setProgress(0);
  };

  const handleClick = () => {
    if (isPending) {
      cancelCountdown();
    } else {
      startCountdown();
    }
  };

  if (isPending) {
    return (
      <button
        className="btn btn-sm btn-default border-0 shadow-sm"
        onClick={handleClick}
        title={`Annuler le masquage de "${columnConfig.title}"`}
        style={{
          padding: "2px 8px",
          fontSize: "0.75em",
          position: "relative",
        }}
      >
        <div className="position-relative d-inline-block">
          {/* Animation SVG du compte à rebours */}
          <svg
            width="22"
            height="22"
            className="position-absolute"
            style={{
              transform: "rotate(-90deg)",
              top: "-3px",
              left: "-3px",
            }}
          >
            {/* Cercle de fond */}
            <circle
              cx="11"
              cy="11"
              r="9"
              fill="none"
              stroke="#e9ecef"
              strokeWidth="2"
            />
            {/* Cercle de progression */}
            <circle
              cx="11"
              cy="11"
              r="9"
              fill="none"
              stroke="#dc3545"
              strokeWidth="2"
              strokeDasharray={`${2 * Math.PI * 9}`}
              strokeDashoffset={`${2 * Math.PI * 9 * (1 - progress / 100)}`}
              style={{
                transition: "stroke-dashoffset 0.016s linear",
              }}
            />
          </svg>
          {/* Icône au centre */}
          <i
            className="fas fa-eye-slash"
            style={{
              fontSize: "11px",
              color: "#dc3545",
            }}
          />
        </div>
      </button>
    );
  }

  return (
    <button
      className="btn btn-sm btn-default border-0 shadow-sm bg-white"
      onMouseEnter={(e) => (e.target.style.opacity = 1)}
      onMouseLeave={(e) => (e.target.style.opacity = 0.5)}
      onClick={handleClick}
      title={`Masquer la colonne "${columnConfig.title}"`}
      style={{
        padding: "2px 8px",
        fontSize: "0.75em",
      }}
    >
      <i className="fas fa-eye-slash " style={{ color: "#6C757D" }}></i>
    </button>
  );
};

export default HideColumnIcon;
